import { createRouter, createWebHistory } from 'vue-router';

import NotFound from '@lib/pages/NotFound.vue';
import Forbidden from '@lib/pages/Forbidden.vue';

import lib_routes from '@lib/router';

const router = createRouter({
	history: createWebHistory(),
	routes: [
		{
			path: '/',
			redirect: '/dashboard',
			component: () => import('@lib/layouts/Dashboard/Main.vue'),
			meta: { auth: true },
			children: [
				// USER ROUTES
				{ path: '/dashboard', name: 'Home', component: () => import('@/pages/User/Dashboard.vue') },
				{ path: '/calendar', component: () => import('@/pages/User/Calendar.vue') },
				{ path: '/profile', component: () => import('@/pages/User/Profile.vue') },
				{ path: '/events', component: () => import('@/pages/User/Events.vue') },
				{
					path: '/events/:id/apply',
					component: () => import('@/pages/User/ApplicationCreate/ApplicationCreate.vue'),
				},
				{
					path: '/applications/:id/complete',
					component: () => import('@/pages/User/ApplicationComplete/ApplicationComplete.vue'),
				},
				{
					path: '/events/:id/intern',
					component: () => import('@/pages/Event/EventIntern.vue'),
				},
				{ path: '/documents', component: () => import('@/pages/User/Documents.vue') },
				{ path: '/time_tracking', component: () => import('@/pages/User/TimeTracking.vue') },
				{ path: '/mails', component: () => import('@/pages/User/Mails.vue') },
				// STAFF ROUTES
				{ path: '/staff/crews', component: () => import('@/pages/Staff/Crews.vue') },
				{ path: '/staff/crews/:id', component: () => import('@/pages/Crew/Settings/Settings.vue') },
				{ path: '/staff/time_tracking', component: () => import('@/pages/Staff/TimeTracking.vue') },
				{
					path: '/staff/staffing_requests',
					component: () => import('@/pages/Staff/StaffingRequests.vue'),
					meta: { permissions: ['staffing_requests.create'] },
				},

				// HR ROUTES
				{
					path: '/hr/users',
					component: () => import('@/pages/HR/Users.vue'),
					meta: { permissions: ['users.read'] },
				},
				{
					path: '/hr/users/:id',
					component: () => import('@/pages/HR/UserSettings.vue'),
					meta: { permissions: ['users.read'] },
				},
				{
					path: '/hr/applications',
					component: () => import('@/pages/HR/Applications.vue'),
					meta: { permissions: ['applications.read'] },
				},
				{
					path: '/hr/staffing_requests',
					component: () => import('@/pages/HR/StaffingRequests.vue'),
					meta: { permissions: ['staffing_requests.read'] },
				},
				{
					path: '/hr/subscriptions',
					component: () => import('@/pages/HR/Subscriptions.vue'),
					meta: { permissions: ['events.read'] },
				},
				{
					path: '/hr/events',
					component: () => import('@/pages/HR/Events.vue'),
					meta: { permissions: ['events.read'] },
				},
				{
					path: '/hr/events/:event_id',
					component: () => import('@/pages/Event/Settings/Settings.vue'),
					meta: { permissions: ['events.read'] },
				},
				{
					path: '/hr/planning',
					component: () => import('@/pages/HR/Planning.vue'),
					meta: { permissions: ['events.read'] },
				},
				{
					path: '/hr/contracts',
					component: () => import('@/pages/HR/Contracts.vue'),
					meta: { permissions: ['users.read'] },
				},
				{
					path: '/hr/payroll',
					component: () => import('@/pages/HR/Payroll.vue'),
					meta: { permissions: ['users.read'] },
				},
				{
					path: '/hr/mail',
					component: () => import('@/pages/HR/Mail.vue'),
					meta: { permissions: ['mails.read'] },
				},

				// FORBIDDEN
				{ path: '/403', name: 'Forbidden', component: Forbidden },

				// STAFF ROUTES
				//{ path: '/staff/subscriptions', component: () => import('@/pages/staff/Subscriptions.vue') },
				//{ path: '/staff/archive', component: () => import('./pages/staff/Archive.vue') },
				//{ path: '/staff/dashboard', component: () => import('./pages/staff/Dashboard.vue') },
				//{ path: '/staff/crews', component: () => import('./pages/staff/Crews.vue') },
				//{ path: '/staff/crews/:id/:eventId', component: () => import('./pages/common/CrewSettings/CrewSettings.vue') },
				//{ path: '/staff/calendar', component: () => import('./pages/staff/Calendar.vue') },
				//{ path: '/staff/schedule_shifts', component: () => import('./pages/staff/ScheduleShifts.vue') },
				//{ path: '/staff/employee', component: () => import('./pages/staff/Employee.vue') },
				//{ path: '/staff/timetracking', component: () => import('./pages/staff/TimeTracking.vue') },

				//{ path: '/applications/:id/complete', component: () => import('@/pages/user/ApplicationComplete.vue') },
				/*// ------
  {
    path: '/profile', component: () => import('./pages/common/Profiles/Profiles.vue'),
  },
  {
    path: '/myevents', component: () => import('./pages/common/MyEvents/MyEvents.vue'),
  },
  {
    path: '/profiles/:id', component: () => import('./pages/common/Profiles/Profiles.vue'),
  },
  {
    path: '/email/inbox', component: () => import('./pages/common/Emails/Inbox.vue'),
  },
  {
    path: '/email/outbox', component: () => import('./pages/common/Emails/Outbox.vue'),
  },
  {
    name: 'email-compose',
    path: '/email/compose', component: () => import('./pages/common/Emails/Compose.vue'),
  },
  {
    path: '/email/detail/:id', component: () => import('./pages/common/Emails/Detail.vue'),
  },
  {
    path: '/email/detail-sent/:id', component: () => import('./pages/common/Emails/DetailSent.vue'),
  },
  {
    path: '/dev', component: () => import('./pages/dev/Components.vue'),
  },*/
				// Admin pages
				{
					path: 'admin/users',
					component: () => import('@lib/pages/Admin/Users.vue'),
					meta: { permissions: ['users.read'] },
				},

				{
					path: 'admin/settings',
					component: () => import('@lib/pages/Admin/Settings/Settings.vue'),
					meta: { permissions: ['app.settings'] },
				},
				{ path: 'admin/maintenance', component: () => import('@lib/pages/Maintenance/Maintenance.vue') },
				{ path: 'admin/development', component: () => import('@lib/pages/Development/Development.vue') },

				// User profile pages
				{ path: 'me', name: 'Profile', component: () => import('@lib/pages/Me/Me.vue') },

				{ path: ':pathMatch(.*)*', name: '404', component: NotFound },
			],
		},
		...lib_routes,
	],
});

export default router;
